import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';

function CloseTicketConfirmModal({ isOpen, onYesCkick, onNoClick }) {
  return (
    <Modal isOpen={isOpen} centered className="modal-close-ticket-confirm">
      <ModalBody>
        <p className="modal-close-ticket-confirm-title">Закрыть тикет?</p>
        <p className="modal-close-ticket-confirm-text">
          Вы собираетесь закрыть обращение. Это действие нельзя будет отменить. Вы уверены?
        </p>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onNoClick}>Отмена</Button>
        <Button color="primary" onClick={onYesCkick}>
          Закрыть
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export { CloseTicketConfirmModal };
